import { computed, effect, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { LocalStore } from '../store/local';
import { ViewportService } from './viewport';

const TRUE: Readonly<string> = 'true';
const FALSE: Readonly<string> = 'false';

const IS_COLLAPSED_KEY: Readonly<string> = 'my_group_is_collapsed';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private localStore: LocalStore = inject(LocalStore);
  private viewportService: ViewportService = inject(ViewportService);

  private readonly _isCollapsed: WritableSignal<boolean> = signal(
    this.localStore.get<string>(IS_COLLAPSED_KEY) === TRUE,
  );
  private readonly _isOverlayOpen: WritableSignal<boolean> = signal(false);

  readonly isCollapsed: Signal<boolean> = computed((): boolean =>
    this.viewportService.isMobile() ? false : this._isCollapsed(),
  );

  readonly isMobile: Signal<boolean> = this.viewportService.isMobile;

  readonly isOverlayOpen: Signal<boolean> = this._isOverlayOpen.asReadonly();

  constructor() {
    let previousIsMobile: boolean = this.viewportService.isMobile();
    effect((): void => {
      const isMobile: boolean = this.viewportService.isMobile();
      if (isMobile === previousIsMobile) return;
      if (!isMobile) this._isOverlayOpen.set(false);
      previousIsMobile = isMobile;
    });
  }

  toggleCollapse(): void {
    this._isCollapsed.update((collapsed: boolean): boolean => {
      this.store(IS_COLLAPSED_KEY, !collapsed);
      return !collapsed;
    });
  }

  openOverlay(): void {
    this._isOverlayOpen.set(true);
  }

  closeOverlay(): void {
    this._isOverlayOpen.set(false);
  }

  private store(key: string, value: boolean): void {
    this.localStore.set(key, value ? TRUE : FALSE);
  }
}
